import axios from 'axios';

// Base da URL: https://api.themoviedb.org/3/
//URL DA API: https://api.themoviedb.org/3/movie/now_playing?api_key=28fc232cc001c31e8a031f419d0a14ca

const api = axios.create({
    baseURL: 'https://api.themoviedb.org/3/'
});

export default api;